var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"hide-no-data":"","items":_vm.items,"label":"Wochentag","item-text":"description","item-value":"id","return-object":""},on:{"change":_vm.select}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }